import ProductDescription from './ProductDescription'

const BSCornmealProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '017BS',
  IsBroadband: false,
  Size: '',
  FDACert: false,
  Organic: false,
}

export default BSCornmealProduct
